<template>
    <rkm-modal
        extra-large
        ref="Modal"
        title="Protocolo - Procedimentos"
    >
        <template v-if="ociModel">
            <rkm-form ref="Form">
                <rkm-table
                    :fields="fields"
                    :items="procedimentos"
                    hide-filters
                    hide-pagination
                >
                    <template v-slot:cell(isRealizado)="{ item }">
                        <rkm-form-checkbox
                            :disabled="readonly"
                            @change="clearFields(item)"
                            v-model="item.isRealizado"
                        />
                    </template>

                    <template v-slot:cell(dataExecutada)="{ item }">
                        <rkm-form-date-picker
                            :disabled="readonly || !item.isRealizado"
                            :max-date="data.additionals.dataAtual"
                            name="Data executada"
                            v-model="item.dataExecutada"
                        />
                    </template>

                    <template v-slot:cell(unidadeExecutora)="{ item }">
                        <rkm-form-select
                            :disabled="readonly || !item.isRealizado"
                            :options="ociModel.oci.unidadesExecutoras"
                            name="Unidade executora"
                            show-default-option
                            text-field="nomeFantasia"
                            v-model="item.unidadeExecutoraId"
                            value-field="id"
                        />
                    </template>

                    <template v-slot:cell(ocupacaoExecutora)="{ item }">
                        <rkm-form-input-autocomplete
                            :disabled="readonly || !item.isRealizado"
                            :repository="repositories.ocupacao"
                            :request-query-string-params="{ procedimento_id: item.id }"
                            :search-fields="[
                                {key: 'ocupacao.codigo', searchable: true},
                                {key: 'ocupacao.nome', searchable: true},
                            ]"
                            :text-field="(item) => item.codigo"
                            name="CBO executora"
                            class="mb-2"
                            v-model="item.ocupacaoExecutora"
                        >
                            <template #itemLabel="{ item }">
                                {{ item.codigo ? `${item.codigo} - ${item.nome}` : null }}
                            </template>
                        </rkm-form-input-autocomplete>
                    </template>

                    <template v-slot:cell(usuarioExecutor)="{ item }">
                        <rkm-form-input
                            :disabled="readonly || !item.isRealizado"
                            :validations="validations.usuarioExecutor"
                            name="Profissional executor"
                            uppercase
                            v-model="item.usuarioExecutor"
                        />
                    </template>
                </rkm-table>
            </rkm-form>
        </template>

        <template v-slot:footer="{cancel}">
            <rkm-button @click="cancel">
                {{ readonly ? 'Fechar' : 'Cancelar' }}
            </rkm-button>

            <rkm-button
                v-if="!readonly"
                color="primary"
                @click="$refs.Form.validate(save)"
            >
                Salvar
            </rkm-button>
        </template>
    </rkm-modal>
</template>

<script>
// Mixins.
import { repository } from '@/mixins'

// Moment.
import moment from 'moment'

// Enums.
import etapaClinica from '@/enums/cadastro/oci/etapaClinica'

export default {
    computed: {
        validations() {
            return {
                usuarioExecutor: { max: 100 }
            }
        },
        readonly() {
            return this.ociModel
                && (
                    this.data.additionals.oci.ultimaEtapaRealizadaMesmoAtendimento
                    || (
                        this.ociModel.oci.etapaClinicaAtualId !== this.enums.etapaClinica.ENTRADA
                        && this.ociModel.oci.etapaClinicaAtualId !== this.enums.etapaClinica.ENTRADA_ALTA
                    )
                )
        }
    },
    created() {
        this.repositories = {
            ocupacao: this.getConectaSusRepository('sigtap.ocupacao')
        }
    },
    data: () => ({
        ociModel: null,
        fields: [
            { key: 'isRealizado', label: 'Realizado', class: 'col-min text-center' },
            { key: 'descricao', label: 'Procedimento' },
            { key: 'dataExecutada', label: 'Data executada' },
            { key: 'unidadeExecutora', label: 'Unidade executora' },
            { key: 'ocupacaoExecutora', label: 'CBO executora' },
            { key: 'usuarioExecutor', label: 'Profissional executor' },
        ],
        procedimentos: [],
        others: { moment },
        enums: { etapaClinica },
    }),
    methods: {
        open(ociModel) {
            this.ociModel = ociModel

            if ((this.ociModel.oci.etapaClinicaAtualId === this.enums.etapaClinica.ENTRADA
                || this.ociModel.oci.etapaClinicaAtualId === this.enums.etapaClinica.ENTRADA_ALTA)
                && !this.data.additionals.oci.ultimaEtapaRealizadaMesmoAtendimento
            ) {

                this.procedimentos = this.ociModel.oci.procedimentosPrimarios.concat(this.ociModel.oci.procedimentosSecundarios)
                    .map(procedimento => {

                        const saved = this.ociModel.oci.procedimentosRealizadosPreviamente.find(p => p.id == procedimento.id)

                        return {
                            id: procedimento.id,
                            codigo: procedimento.codigo,
                            descricao: procedimento.descricao,
                            isRealizado: saved ? saved.isRealizado : false,
                            dataExecutada: saved
                                ? (saved.dataExecutada ? this.others.moment(saved.dataExecutada, 'DD/MM/YYYY').toDate() : null)
                                : null,
                            unidadeExecutoraId: saved ? saved.unidadeExecutoraId : null,
                            ocupacaoExecutora: saved ? saved.ocupacaoExecutora : null,
                            usuarioExecutor: saved ? saved.usuarioExecutor : null,
                        }
                    })
            }
            else {

                this.procedimentos = this.ociModel.oci.procedimentosRealizadosPreviamenteSaved
                    .map(procedimento => {

                        return {
                            id: procedimento.id,
                            codigo: procedimento.codigo,
                            descricao: procedimento.descricao,
                            isRealizado: procedimento.isRealizado,
                            dataExecutada: procedimento.dataExecutada ? this.others.moment(procedimento.dataExecutada, 'DD/MM/YYYY').toDate() : null,
                            unidadeExecutoraId: procedimento.unidadeExecutoraId,
                            ocupacaoExecutora: procedimento.ocupacaoExecutora,
                            usuarioExecutor: procedimento.usuarioExecutor,
                        }
                    })
            }

            this.$refs.Modal.show()
        },
        save() {
            this.ociModel.oci.procedimentosRealizadosPreviamente = this.procedimentos
                .filter(p => p.isRealizado)
                .map(procedimento => ({
                    id: procedimento.id,
                    codigo: procedimento.codigo,
                    descricao: procedimento.descricao,
                    isRealizado: true,
                    dataExecutada: procedimento.dataExecutada ? this.others.moment(procedimento.dataExecutada).format('DD/MM/YYYY') : null,
                    unidadeExecutoraId: procedimento.unidadeExecutoraId,
                    ocupacaoExecutoraId: procedimento.ocupacaoExecutora ? procedimento.ocupacaoExecutora.id : null,
                    ocupacaoExecutora: procedimento.ocupacaoExecutora,
                    usuarioExecutor: procedimento.usuarioExecutor
                }))

            this.$refs.Modal.hide()
        },
        clearFields(procedimento) {
            procedimento.dataExecutada = null
            procedimento.unidadeExecutoraId = null
            procedimento.ocupacaoExecutora = null
            procedimento.usuarioExecutor = null
        }
    },
    mixins: [repository],
    props: {
        data: { type: Object, required: true },
    }
}
</script>